import React, { type ReactElement, useState } from 'react';

import { Box } from '@mui/material';

import Checkmark from 'assets/icons/icn _ 24px _ verified.svg?react';
import TMXTooltip from 'components/tooltip/TMXTooltip';
import { BodyLarge } from 'components/typography/Typography';

import { useStyles } from './styles';

interface WTNTypographyProps {
  rating: number;
  checkmarkColor?: string;
  confidenceDescription?: string;
}

function WTNTypography({ rating, checkmarkColor, confidenceDescription }: WTNTypographyProps): ReactElement {
  const { classes } = useStyles({ checkmarkColor: checkmarkColor ?? '#d0d3db' });
  const [tooltipOpen, setTooltipOpen] = useState<boolean>(false);
  const ratingDisplay = Number.isFinite(rating) ? rating.toFixed(2) : '-';

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'flex-start', columnGap: 0.5 }}>
      {ratingDisplay}
      {Number.isFinite(rating) && !!confidenceDescription && (
        <TMXTooltip
          arrow
          classes={{ tooltip: classes.wtnTooltip }}
          open={tooltipOpen}
          placement="top"
          title={<BodyLarge className={classes.wtnTooltipText}>{confidenceDescription}</BodyLarge>}
          onClose={() => setTooltipOpen(false)}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Checkmark
              className={classes.wtnCheckmark}
              fill="red"
              onMouseEnter={() => setTooltipOpen(true)}
              onMouseLeave={() => setTooltipOpen(false)}
            />
          </Box>
        </TMXTooltip>
      )}
    </Box>
  );
}

export default React.memo(WTNTypography);
